$(() => {
  // semantic ui のグローバル動作
  $('.ui.dropdown').dropdown();
  // アコーディオン (exclusive: false で他の要素を自動で閉じない)
  $('.ui.accordion').accordion({ exclusive: false });

  // ページ内リンクのスムーススクロール
  $(document).on('click', 'a[href^="#"]', function() {
    const headerOffset = 50;
    const speed = 500;
    const zm = parseInt($('body').css('zoom')) || 1; // zoom対策
    let target = $('a[name="' + this.hash.replace('#', '') + '"]');
    let targetY;
    if (target.length) {
      targetY = (target.offset().top) * zm + window.pageYOffset - headerOffset;
    } else {
      target = $('html');
      targetY = 0;
    }
    $('html, body').stop().animate({ scrollTop: targetY }, speed, 'swing');
    window.history.pushState(null, null, this.hash);
    return false;
  });
});

// 複数行テキストリストコントロール
$(() => {
  const multilist = $('.multilist');
  $('.add.button', multilist).on('click', function() {
    const text = window.prompt('追加する値を入力してください。');
    if (!text) return false;
    const newItem = $('<option>').text(text).attr('value', text);
    $('select', $(this).closest('.multilist')).append(newItem);
  });
  const getSelectedItem = (sibling) => {
    const select = $('select', $(sibling).closest('.multilist'));
    return $(':selected', select);
  };
  $('.remove.button', multilist).on('click', function() {
    if (!window.confirm('削除してよろしいですか？')) return false;
    getSelectedItem(this).remove();
  });
  $('.moveup.button', multilist).on('click', function() {
    const selected = getSelectedItem(this);
    const prev = selected.prev('option');
    if (!selected.length || !prev.length) return false;
    selected.remove().insertBefore(prev);
  });
  $('.movedown.button', multilist).on('click', function() {
    const selected = getSelectedItem(this);
    const next = selected.next('option');
    if (!selected.length || !next.length) return false;
    selected.remove().insertAfter(next);
  });
});

// ページ内目次関連の処理
$(() => {
  // ページ内目次メニューのアクティブアイテム切り替え
  const selectTocItem = item => {
    const menu = $(item).closest('.toc.menu');
    $('.item', menu).removeClass('active');
    $(item).addClass('active');
  }
  // スクロール位置に応じてページ内目次メニューのアクティブアイテムを切り替える
  const refreshActiveTocItem = () => {
    // 判断の基準位置
    const baseY = 50;
    // 現在のスクロール位置
    const scrollY = window.pageYOffset;
    const diffs = $('.toc.menu > a[href]')
      .get()
      .map(item => {
        // アンカー名取得
        const name = $(item).attr('href').replace('#', '');
        // アンカー要素を検索
        const anchor = $('a[name="' + name + '"]');
        // アンカーが存在する場合はその位置、なければ現在のスクロール位置を相対位置とする
        let pos = anchor.length ? anchor.offset().top : -scrollY;
        // 一定位置までは最初の要素を優先させるために他のアンカーを除外する
        if (anchor.length && scrollY < baseY) pos = 999999;
        return {
          item: item,
          pos: pos,
          // 差分位置は基準位置との差
          diff: Math.abs(pos - baseY),
        };
      });
    // 基準位置ともっとも近いアンカーを抽出
    const min = diffs.reduce((p, x) => p.diff < x.diff ? p : x);
    // 目次メニューのアクティブアイテム切り替え
    selectTocItem(min.item);
  };
  // スクロール時のイベントハンドラ設定
  $(document).on('scroll', refreshActiveTocItem);
  // ロード時トリガー
  refreshActiveTocItem();
});

// 検索条件エリアの動作実装
$(() => {
  // 検索条件 表示/非表示 ボタン
  $('.hide-search-condition').on('click', function() {
    const target = $('.search.condition');
    const isVisible = target.is(':visible');
    if (isVisible) {
      target.slideUp();
      $('.icon', this).removeClass('up').addClass('down');
    } else {
      target.slideDown();
      $('.icon', this).removeClass('down').addClass('up');
    }
  });
  // 検索条件 増減ボタン
  const container = $('#search-condition')
  const getCount = () => $('tbody > tr', container).length
  const resetCommand = () => {
    $('tbody > tr .remove.condition', container).show();
    if (getCount() === 1) {
      $('tbody > tr:first-child .remove.condition', container).hide();
    }
  }
  // ロード時トリガー
  resetCommand();
  container
    .on('click', '.add.condition', function() {
      const row = $(this).closest('tr');
      const newRow = row.clone();
      newRow.insertAfter(row);
      $('input, select', newRow).val('')
        .find(":checked").prop("checked", false);
      resetCommand();
    })
    .on('click', '.remove.condition', function() {
      $(this).closest('tr').remove();
      resetCommand();
    })
});



// WEBPACK FOOTER //
// ./src/main.js